export default __webpack_public_path__ + "static/media/bg5.ef33a5c2.svg";